import { Injectable, inject } from '@angular/core';
//
import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { ToDoModel } from '../../models/todo.model';
import { DbContext } from '../../core/utils/db-context';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';

@Injectable({
    providedIn: 'root'
})
export class TodosRepository extends BaseEntityRepository<ToDoModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(r => r.tableName === DbContext.Todos);
    }
}
